export function extractDataFromPath(
  pathname: string,
): [string, string, string] {
  const [country, language, slug] = pathname.split('/').filter(Boolean)
  return [country, language, slug]
}
